import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type ZebraMachine } from "@packsize/schemas/machines";

import { getZebraMachines } from "@/api/machines/zebra-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { ZEBRA_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getZebraMachinesQuery = <TData = ZebraMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: ZEBRA_MACHINES_QUERY_KEY,
	queryFn: getZebraMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useZebraMachines = (
	options?: UseMachinesQueryOptions<ZebraMachine[], Error>,
): UseQueryResult<ZebraMachine[], Error> => {
	return useQuery<ZebraMachine[], Error>(getZebraMachinesQuery(options));
};
